module.exports = __webpack_public_path__ + "img/prezwww.e7c83ce2.png";